import React, { useCallback } from "react";
import { GoogleMap, Marker, Polyline, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "320px",
    borderRadius: "14px",
};

const FALLBACK_CENTER = { lat: 33.006257, lng: 73.15074 };

// markers: [{ lat, lng, label, color, title }]
const ShiftMap = ({ markers = [], showPath = false, emptyMessage = "No location data recorded" }) => {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ["places", "geometry"],
    });

    const onLoad = useCallback(
        (map) => {
            if (markers.length > 1 && window.google) {
                const bounds = new window.google.maps.LatLngBounds();
                markers.forEach((m) => bounds.extend({ lat: m.lat, lng: m.lng }));
                map.fitBounds(bounds, 60);
            }
        },
        [markers],
    );

    if (!isLoaded) {
        return (
            <div style={{ ...containerStyle, display: "flex", alignItems: "center", justifyContent: "center", background: "#f1f5f9", color: "#64748b", fontSize: "13.5px" }}>
                <i className="pi pi-spin pi-spinner" style={{ marginRight: "8px" }} />
                Loading map...
            </div>
        );
    }

    if (!markers.length) {
        return (
            <div style={{ ...containerStyle, display: "flex", alignItems: "center", justifyContent: "center", background: "#f1f5f9", color: "#64748b", fontSize: "13.5px" }}>
                {emptyMessage}
            </div>
        );
    }

    const center = markers.length === 1 ? { lat: markers[0].lat, lng: markers[0].lng } : FALLBACK_CENTER;

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={markers.length > 1 ? 12 : 15}
            onLoad={onLoad}
            options={{
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: true,
                zoomControl: true,
                clickableIcons: false,
            }}
        >
            {showPath && markers.length > 1 && (
                <Polyline
                    path={markers.map((m) => ({ lat: m.lat, lng: m.lng }))}
                    options={{ strokeColor: "#6366f1", strokeOpacity: 0.85, strokeWeight: 4 }}
                />
            )}
            {markers.map((m, idx) => (
                <Marker
                    key={idx}
                    position={{ lat: m.lat, lng: m.lng }}
                    title={m.title}
                    label={
                        m.label
                            ? {
                                  text: m.label,
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "11px",
                              }
                            : undefined
                    }
                    icon={{
                        path: window.google.maps.SymbolPath.CIRCLE,
                        scale: 13,
                        fillColor: m.color || "#6366f1",
                        fillOpacity: 1,
                        strokeColor: "#ffffff",
                        strokeWeight: 2,
                    }}
                />
            ))}
        </GoogleMap>
    );
};

export default ShiftMap;
